import { Fragment, useState } from "react";
import usePage from "../hooks/usePage";
import Menu from "../modules/public/menu/menu";
import Footer from "../modules/public/footer/footer";
import { Container, Row, Col, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./InternalPage.css";

const InternalPage = () => {
  const { pageSliders, pageImage, pageText } = usePage();

  const [state, setState] = useState({
    showModalOnlinePayment: false,
    showModalAfterRent: false,
    showModalCOD: false,
    showModalBulk: false,
  });

  return (
    <Fragment>
      <Menu />

      <main className="flex-grow-1">
        {pageSliders}

        <Container>
          <Row className="first" style={{ justifyContent: "center" }}>
            <Col className="iconCol" xs={6} sm={6} md={6} lg={3} xl={3}>
              <div className="option-links">
                <button
                  className="buttonUi a-links"
                  id="pardakhtOnlineInternal"
                  type="button"
                  onClick={() =>
                    setState(cur => ({ ...cur, showModalOnlinePayment: true }))
                  }
                >
                  <img
                    src="./iconsRounded/online.png"
                    style={{
                      display: "flex",
                      maxWidth: "100%",
                      marginRight: 15,
                    }}
                  />
                </button>
              </div>
            </Col>

            <Col className="iconCol" xs={6} sm={6} md={6} lg={3} xl={3}>
              <div className="option-links">
                <button
                  className="buttonUi a-links"
                  id="forooshgahInter"
                  type="button"
                  onClick={() =>
                    setState(cur => ({ ...cur, showModalAfterRent: true }))
                  }
                >
                  <img
                    src="/iconsRounded/after.png"
                    style={{
                      display: "flex",
                      maxWidth: "100%",
                    }}
                  />
                </button>
              </div>
            </Col>

            <Col className="iconCol" xs={6} sm={6} md={6} lg={3} xl={3}>
              <div className="option-links ">
                <button
                  className="buttonUi a-links"
                  type="button"
                  onClick={() =>
                    setState(cur => ({ ...cur, showModalCOD: true }))
                  }
                >
                  <img
                    src="./iconsRounded/cod.png"
                    style={{
                      display: "flex",
                      maxWidth: "100%",
                    }}
                  />
                </button>
              </div>
            </Col>

            <Col className="iconCol" xs={6} sm={6} md={6} lg={3} xl={3}>
              <div className="option-links">
                <button
                  className="buttonUi a-links"
                  type="button"
                  onClick={() =>
                    setState(cur => ({ ...cur, showModalBulk: true }))
                  }
                >
                  <img
                    src="./iconsRounded/bulk.png"
                    style={{
                      display: "flex",
                      maxWidth: "100%",
                    }}
                  />
                </button>
              </div>
            </Col>
          </Row>

          {pageText}

          {pageImage}
        </Container>

        <Modal
          show={state.showModalOnlinePayment}
          direction="rtl"
          style={{ textAlign: "right", fontSize: "18px" }}
        >
          <Modal.Header className="d-flex align-item-center justify-content-center">
            <Modal.Title>پرداخت آنلاین یا پیشکرایه</Modal.Title>
          </Modal.Header>
          <Modal.Body
            className="d-flex align-item-center justify-content-center text-right "
            style={{ textAlign: "right", direction: "rtl" }}
          >
            <div className="w-100">
              <Row>
                <p style={{ fontSize: "18px" }}>
                  با انتخاب روش پیشکرایه یا پرداخت آنلاین تمامی هزینه های پستی
                  توسط فرستنده پرداخت می شود.
                </p>
              </Row>
              <Modal.Footer className="d-flex align-item-center justify-content-center">
                <Link
                  className="btn-success-style text-center"
                  to="/onlinePayment"
                >
                  فهمیدم و ادامه
                </Link>
                <button
                  className="btn-cancel-style"
                  onClick={() =>
                    setState(cur => ({ ...cur, showModalOnlinePayment: false }))
                  }
                >
                  انصراف
                </button>
              </Modal.Footer>
            </div>
          </Modal.Body>
        </Modal>

        <Modal show={state.showModalAfterRent} direction="rtl">
          <Modal.Header className="d-flex align-item-center justify-content-center">
            <Modal.Title>پسکرایه</Modal.Title>
          </Modal.Header>
          <Modal.Body
            className="d-flex align-item-center justify-content-center text-right "
            style={{ textAlign: "right", direction: "rtl" }}
          >
            <div className="w-100">
              <Row>
                <p style={{ fontSize: "18px" }}>
                  با انتخاب روش پسکرایه تمامی هزینه های پستی توسط گیرنده پرداخت
                  می شود.
                </p>
              </Row>
              <Modal.Footer className="d-flex align-item-center justify-content-center">
                <Link
                  className="btn-success-style text-center" //onClick={() => {showModalOnlinePayment(false)}}
                  to="/payinplace"
                >
                  فهمیدم و ادامه
                </Link>
                <button
                  className="btn-cancel-style"
                  onClick={() =>
                    setState(cur => ({ ...cur, showModalAfterRent: false }))
                  }
                >
                  انصراف
                </button>
              </Modal.Footer>
            </div>
          </Modal.Body>
        </Modal>

        <Modal show={state.showModalCOD} direction="rtl">
          <Modal.Header className="d-flex align-item-center justify-content-center">
            <Modal.Title>پرداخت در محل - COD</Modal.Title>
          </Modal.Header>
          <Modal.Body
            className="d-flex align-item-center justify-content-center text-right "
            style={{ textAlign: "right", direction: "rtl" }}
          >
            <div className="w-100">
              <Row>
                <p style={{ fontSize: "18px" }}>
                  با انتخاب روش پرداخت در محل تمامی هزینه های پستی به اضافه مبلغ
                  COD تعیین شده در فاکتور توسط گیرنده پرداخت میشود.
                </p>
              </Row>
              <Modal.Footer className="d-flex align-item-center justify-content-center">
                <Link
                  className="btn-success-style text-center"
                  to="/payinplace"
                >
                  فهمیدم و ادامه
                </Link>
                <button
                  className="btn-cancel-style"
                  onClick={() =>
                    setState(cur => ({ ...cur, showModalCOD: false }))
                  }
                >
                  انصراف
                </button>
              </Modal.Footer>
            </div>
          </Modal.Body>
        </Modal>

        <Modal show={state.showModalBulk} direction="rtl">
          <Modal.Header className="d-flex align-item-center justify-content-center">
            <Modal.Title>سفارش انبوه</Modal.Title>
          </Modal.Header>
          <Modal.Body
            className="d-flex align-item-center justify-content-center text-right "
            style={{ textAlign: "right", direction: "rtl" }}
          >
            <div className="w-100">
              <Row>
                <p style={{ fontSize: "18px" }}>
                  با انتخاب روش سفارش انبوه میتوانید ثبت مرسولات خود از یک مبدا
                  واحد برای مقصدهای متفاوت را در یک فرم انجام دهید
                </p>
              </Row>
              <Modal.Footer className="d-flex align-item-center justify-content-center">
                <Link to="/bulkOrder" className="btn-success-style text-center">
                  فهمیدم و ادامه
                </Link>
                <button
                  className="btn-cancel-style"
                  onClick={() =>
                    setState(cur => ({ ...cur, showModalBulk: false }))
                  }
                >
                  انصراف
                </button>
              </Modal.Footer>
            </div>
          </Modal.Body>
        </Modal>
      </main>

      <Footer />
    </Fragment>
  );
};

export default InternalPage;
